///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2023, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import * as THREE from "three";
import { IComponent } from "../IComponent";
import type { ThreejsViewer } from "../ThreejsViewer";

export class LightComponent implements IComponent {
  protected viewer: ThreejsViewer;
  protected ambientLight: THREE.AmbientLight;
  protected directLight: THREE.DirectionalLight;

  constructor(viewer: ThreejsViewer) {
    this.viewer = viewer;

    this.ambientLight = new THREE.AmbientLight(0xffffff, 0);
    this.viewer.camera.add(this.ambientLight);

    this.directLight = new THREE.DirectionalLight(0xffffff, 1);
    this.directLight.position.set(0.5, 0, 0.866); // ~60º
    this.viewer.camera.add(this.directLight);
  }

  dispose() {
    this.ambientLight.removeFromParent();
    this.directLight.removeFromParent();
  }
}
